import ShowChartIcon from "@mui/icons-material/ShowChart";
import type { FC } from "react";

import { EmbedSettings } from "~/feature/chart/components/EmbedSettings";
import { EMBED_FORMAT } from "~/feature/citeEmbed/constants";
import type { ICiteEmbedEvent } from "~/feature/citeEmbed/types";
import type { IMarket } from "~/types/event";

import * as Styled from "./EmbedTab.styles";

interface IEmbedTabProps {
  event: ICiteEmbedEvent;
  markets: IMarket[];
  defaultSelection: string[];
}

export const EmbedTab: FC<IEmbedTabProps> = ({
  event,
  markets,
  defaultSelection,
}) => (
  <Styled.Root>
    <Styled.Formats>
      <Styled.FormatChip type="button" aria-pressed="true">
        <ShowChartIcon />
        {EMBED_FORMAT.chart}
      </Styled.FormatChip>
    </Styled.Formats>
    <EmbedSettings
      event={event}
      markets={markets}
      defaultSelection={defaultSelection}
    />
  </Styled.Root>
);
